import { MemberFeature, MemberFeatures } from '@trello/product-features';

export function hasGold(products: number[]) {
  return MemberFeatures.isFeatureEnabled(MemberFeature.Crown, products[0]);
}
